<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"> </p>
<p class="ser"> </p>
<p class="ser"> </p>
<p class="tx1">HELLO, WELL-INTENTIONED PERSON OF PALLOR!</p>
<p class="ser"> </p>
<p class="tx1">It’s Daquan—the black coworker you are referring to when you claim to have black friends.</p>
<p class="ser"> </p>
<p class="tx1">You are reading this book because you want to know what not to say. They get mad at you when you say the wrong thing. But no one will tell you, up front, what not to say. Well, I will tell you. Because I am your friend. Your real black friend.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// intro1.vue?c8737bf6